import { useMemo } from "react";
import { SyncSelection } from "../types";

export const normalizeForSearch = (value: string): string =>
  value
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();

interface Params {
  selections: SyncSelection[];
  query: string;
}

const useFilteredSyncSelections = ({ selections, query }: Params) => {
  const normalizedNames = useMemo(
    () => selections.map((selection) => normalizeForSearch(selection.name ?? "")),
    [selections],
  );

  const normalizedQuery = useMemo(() => normalizeForSearch(query.trim()), [query]);

  const visibleSelections = useMemo(
    () =>
      normalizedQuery
        ? selections.filter((_, index) => normalizedNames[index].includes(normalizedQuery))
        : selections,
    [selections, normalizedNames, normalizedQuery],
  );

  return { visibleSelections };
};

export default useFilteredSyncSelections;
